/**
 * vuex的状态
 * 注意：
 *  1、每个状态必须有注释
 *  2、不要把状态都放到vuex里管理，有需要的才放；
 */
//引入websocket的mixin
export default {
  token: "",//token
  userName: "",//用户名
  userInfo: {},
  systemData:{
    name:"",
    logo:""
  },
  fullScreen:false,
  areaData:[]
}



// WEBPACK FOOTER //
// ./src/store/zhongheng/state.js